export default __webpack_public_path__ + "static/media/verification.9aa82b7c.svg";